import { I18n } from '@boschebike/ebds-js';
import thirdPartyLicenses from '../../../static/third-party-licenses/third-party-licenses.json';
import { HeaderProps, PageTabless } from '../../components';
import { Container } from '../../components/layout/Container';
import { useContent } from '../../hooks/use-content';

export const ThirdPartyLicensesPage = () => {
  const content: I18n = useContent();
  const header: HeaderProps = {
    title: content.t('portal.thirdPartyLicenses.headline'),
    headline: content.t('portal.thirdPartyLicenses.subheadline'),
    lightWeight: true,
  };

  return (
    <PageTabless headerProps={header}>
      {thirdPartyLicenses.map((d) => (
        <Container key={d.area} customContainerClassName='third-party-licenses_list'>
          {d.area && <h2>{d.area}</h2>}
          <Container multiColumn>
            <ul>
              {d.dependencies.map((dep) => (
                <li key={dep.name}>
                  <span>{dep.name}</span>{' '}
                  <span>
                    <a
                      target="_blank"
                      href={dep.licenseURL}
                      rel="noreferrer"
                    >
                      {dep.licenseName}
                    </a>
                  </span>
                </li>
              ))}
            </ul>
          </Container>
        </Container>
      ))}
    </PageTabless>
  );
};
